import * as React from 'react';
import { styled } from '@linaria/react';

interface Props {}

function MobileWire({}: Props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      fill="none"
      viewBox="0 0 100 200"
    >
      <path
        d={`
          M 50 0
          C 120 66
            0 132
            50 200
        `}
      />
    </Svg>
  );
}

const Svg = styled.svg`
  display: block;
  overflow: visible;
  width: 100px;

  path {
    stroke: var(--color-gray-700);
    stroke-width: 3px;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export default MobileWire;
